<svelte:options customElement={{ tag: "bt-pdf-button", shadow: "none", }} />

<script lang="ts">
  import Icon from '$shared/icons/Icon.svelte';
  import Checkbox from '$shared/checkbox/Checkbox.svelte'
  import LoadingIcon from '../icons/loading.svg.svelte';

  export let text: string = 'Download PDF';
  export let clickedText = 'Downloading...';
  export let link = '';
  export let hasCheckbox = false;
  export let checkboxText = '';

  export let isLoading = false;
  let checkboxValue;

  let buttonEl: DOMElement;
  let clickedTextEl: DOMElement;
  let defaultTextEl: DOMElement;
  let clickedIconEl: DOMElement;
  let defaultIconEl: DOMElement;

  const generatePDF = (event) => {
    event.preventDefault()
    buttonEl.classList.add("disabled")
    isLoading = true;

    if (checkboxValue) {
      if (link.includes("?")) {
        link += "&include_answers=true";
      } else {
        link += "?include_answers=true";
      }
    } else {
      link = link.split("?")[0];
    }
    
    generatePDFAsync(link)
      .then(({ blob, filename }) => {
        downloadPDF(blob, filename)
        buttonEl.classList.remove("disabled")
        isLoading = false;
      })
      .catch((error) => {
        window.setTimeout(() => {
          console.error("Error generating PDF:", error)
          buttonEl.classList.remove("disabled")
          isLoading = false;
        }, 1000)
      })
  }
  const generatePDFAsync = async(url) => {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/pdf',
        'X-Requested-With': 'XMLHttpRequest', // This is required for Rails
        // @ts-ignore
        'X-CSRF-Token': document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute('content')
      },
      credentials: 'same-origin',
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const blob = await response.blob()
    const contentDisposition = response.headers.get('Content-Disposition')
    let filename = 'download.pdf'  // Default filename

    // Try to extract filename from Content-Disposition header
    if (contentDisposition) {
      // First, try to get the filename* parameter (RFC 5987)
      const filenameStarMatch =
        /filename\*=UTF-8''(.+)/i.exec(contentDisposition)
      if (filenameStarMatch) {
        filename = decodeURIComponent(filenameStarMatch[1])
      } else {
        // If filename* is not found, try the regular filename parameter
        const filenameMatch = /filename="?(.+)"?/i.exec(contentDisposition)
        if (filenameMatch) {
          filename = filenameMatch[1].replace(/['"]/g, '')
        }
      }
    }

    return { blob, filename }
  }

  const downloadPDF = (blob, filename) => {
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = url
    link.download = decodeURIComponent(filename)
    link.click()

    // Release the object URL after the download is complete
    setTimeout(() => URL.revokeObjectURL(url), 100)
  }

</script>

<div class="pdf-button">
  <a href="{link}" 
    bind:this={buttonEl}
    on:click={generatePDF}
    class="border group
    text-white 
    hover:bg-transparent hover:text-neutral-900">
    <div>
      <span class={`font-medium ${isLoading ? 'mr-2' : 'hidden'}`} bind:this={clickedTextEl}>{clickedText}</span>
      <span class={`font-medium ${isLoading ? 'hidden' : ''}`} bind:this={defaultTextEl}>{text}</span>
    </div>
    <span bind:this={defaultIconEl} class={`ml-4 ${isLoading ? 'hidden' : ''}`}>
      <Icon icon="PDF" size="medium"></Icon>
    </span>
    <div bind:this={clickedIconEl} class="{`${isLoading ? '' : 'hidden'}`}">
      <LoadingIcon/>
    </div>
  </a>
</div>

{#if hasCheckbox}
  <Checkbox label={checkboxText} design="checkmark" bind:isChecked={checkboxValue}/>
{/if}

<style>
  .pdf-button {
    display: flex;
  }
  a {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    max-height: 42px;
    padding: theme('padding.4');
    margin-top: theme('margin.8');
    font-size: theme('fontSize.sm');
    color: black;
    border: 1px solid theme('colors.neutral.300');
    background: white;
    &:hover {
      border: 1px solid theme('colors.neutral.900');
      color: theme('colors.neutral.900');
      background: transparent;
    }
  }
  a div {
    display: flex;
    flex-direction: column;
    max-width: 75%;
    text-align: left;
  }
  span {
    white-space: nowrap;
  }
  /* Necessary to duplicate this from theme.css so that not overriden by display: flex */
  .hidden {
    display: none;
  }
  @media print {
    a {
      display: none !important;
    }
  }

  .checkbox {
    display: flex;
    align-items: center;
    height: theme('spacing.6');
    margin-top: theme('spacing.2');
    span {
      display: inline-block;
      margin-left: theme('spacing.1');
      &:hover {
        cursor: pointer;
      }
    }
    input[type="checkbox"] {
      -webkit-appearance: none;
      appearance: none;
      background-color: transparent;
      margin: 0;
      font: inherit;
      color: currentColor;
      width: theme('spacing.4');
      height: theme('spacing.4');
      border: theme('borderWidth.2') solid currentColor;
      display: grid;
      place-content: center;
      &:hover {
        cursor: pointer;
      }
      &:before {
        content: '';
        width: theme('spacing.2');
        height: theme('spacing.2');
        transform: scale(0);
        transition: 100ms transform ease-in-out;
        box-shadow: inset theme('spacing.4') theme('spacing.4') theme('colors.sky-blue');
        /* Windows High Contrast Mode */
        background-color: CanvasText;
      }
      &:hover::before {
        transform: scale(.5);
      }

      &:checked::before {
        transform: scale(1);
      }

      &:focus {
        outline: 1px solid theme('colors.sky-blue');
        outline-offset: 1px;
      }
    }
  }
</style>
